export enum SegmentEvents {
  cardClicked = 'Card Clicked',
  cardViewed = 'Card Viewed',
  cardArchived = 'Card Archived',
  cardSaved = 'Card Saved',
  cardRestored = 'Card Restored',
}
